// @ts-nocheck
import { createCommissionTemplate } from './commissionTemplateHelpers.js';

export default createCommissionTemplate({
  pharmaceuticalCompanyName: '휴비스트제약',
  targetSheetName: '1.요율표',
  headerRowIndex: 12,
  headerRowCount: 1,
  dataStartRowIndex: 13,
  repeatedHeaderRowAction: 'skip',
  columnMapping: {
    drugCode: '보험코드',
    drugName: '제품명',
    price: '약가',
    commissionRate: '요율',
  },
  requiredHeaders: [
    'NO',
    '전문/일반',
    '효능군',
    '제품명',
    '성분함량',
    '대조약',
    '약가',
    '요율',
    '보험코드',
    '규격(소)',
    '규격(대)',
  ],
});
